import styled from "styled-components";

export const FloatingLogoWrap = styled("div")`
	position: fixed;
	left: 1rem;
	top: 30vh;
	z-index: 1;
	opacity: 0.12;
	pointer-events: none;
	will-change: transform;

	@media only screen and (max-width: 890px) {
		left: 0.5rem;
		opacity: 0.08;
	}
`;
